import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-static-article",
  templateUrl: "./static-article.component.html",
  styleUrls: ["./static-article.component.css"],
})
export class StaticArticleComponent implements OnInit {
  constructor(private router: Router,  private routing: Router) {}

  @Input() settings: any;
  @Input() public data: any;
  public site: any;
  public prefix: any;
  ngOnInit() {
    for (let i = 0; i < this.settings.ImagesLink.length; i++) {
      this.settings.ImagesLink[i].articaltitle =
        this.settings.ImagesLink[i].articaltitle ||
        this.settings.ImagesLink[i].articalsTitle;
      this.settings.articaltitle =
        this.settings.articaltitle || this.settings.articalsTitle;
    }
    this.site = this.data.moduleService.site;
    this.prefix = "/" + this.data.moduleService.site.HostName;
  }
  public navigateToPage(artical) {
    this.router.navigate(["/" + artical.page]);
    if (artical.sectionId) {
      setTimeout(() => {
        this.navigateToSection(artical.sectionId);
      }, 200);
    }
  }
  public GoTopage(artical) {
    this.routing.navigate([this.prefix + "/" + artical.blog]);
  }
  public navigateToSection(el) {
    const elmnt = document.getElementById(el);
    if (elmnt && elmnt != null) {
      elmnt.scrollIntoView();
    }
  }
  
}
